import {Injectable} from '@angular/core';
import {BatchManager} from 'src/app/data/manager/batch/batch.manager';
import {ProductInterface} from 'src/app/data/networking/models/shared/responses/product-response';

@Injectable({
  providedIn: 'root',
})
export class VtoPlayerVm {
  constructor(private batchManager: BatchManager) {}

  logEvent(product: ProductInterface, timeToUse: number) {
    const eventData = {
      time_use_modiface: timeToUse,
      category: product?.departments?.[0] || '-',
      discount: product?.fullPrice && product?.offerPrice ? product?.fullPrice - product?.offerPrice : 0,
      prime_price: product?.primePrice || 0,
      quantity: 1,
      offer_price: product?.offerPrice || 0,
      full_price: product?.fullPrice || 0,
      order_channel: 'Online',
      name: product?.description || '-',
      brand: product?.marca || '-',
      id: product?.id || '-',
      departament: product?.classification?.find(c => c.typeName === 'DEPARTAMENTO')?.name || '-',
      subcategory: product?.classification?.find(c => c.typeName === 'SUBCATEGORIA')?.name || '-',
      variant: product?.detailDescription?.trim() || '-',
    };

    return this.batchManager.logEvent('use_modiface', eventData);
  }
}
